import dayjs from "dayjs";

import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import "dayjs/locale/en-gb";

dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.locale("en-gb");

const tz = "Europe/Kiev";

dayjs.tz.setDefault(tz);

export default dayjs.tz;
export { dayjs as dayjsInstance };
